import React from 'react'
import { Col } from 'react-bootstrap'
import FormProdcutType from './FormProdcutType'

export default function ProductTypeFormContentView(props) {
    const { formik } = props

    return (
        <React.Fragment>
            <div className="app-card mb-3 mb-lg-4">
                <div className="app-header-wrapper heading-sm mb-1">
                    <p className="app-heading text-capitalize">Product Type Detail</p>
                </div>
                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T pad-20-B">
                    <Col xs={12} md={9} lg={6} className="px-0">
                        <FormProdcutType
                            formik={formik}
                        />
                    </Col>
                </div>
            </div>
        </React.Fragment>
    )
}
